import modelService from '@/services/model'

export default {

  userIndex: (cbOk, cbErr, userId, weeks) => {
    return modelService.index(cbOk, cbErr, `/users/${userId}/watches.json?weeks=${weeks}`)
  },

  projectIndex: (cbOk, cbErr, projectId, weeks) => {
    return modelService.index(cbOk, cbErr, `/projects/${projectId}/watches.json?weeks=${weeks}`)
  },

  boardIndex: (cbOk, cbErr, boardId, weeks) => {
    return modelService.index(cbOk, cbErr, `/boards/${boardId}/watches.json?weeks=${weeks}`)
  },

  // NOTE: there is not much point to this, it will only ever return one result, our possible watch on this ticket
  // However, it is used so we preserve it
  ticketIndex: (cbOk, cbErr, ticketId) => {
    return modelService.index(cbOk, cbErr, `/tickets/${ticketId}/watches.json`)
  },

  projectCreate: (cbOk, cbErr, projectId, instance) => {
    return modelService.create(cbOk, cbErr, {watch: instance}, `/projects/${projectId}/watches.json`)
  },

  boardCreate: (cbOk, cbErr, boardId, instance) => {
    return modelService.create(cbOk, cbErr, {watch: instance}, `/boards/${boardId}/watches.json`)
  },

  ticketCreate: (cbOk, cbErr, ticketId, instance) => {
    return modelService.create(cbOk, cbErr, {watch: instance}, `/tickets/${ticketId}/watches.json`)
  },

  // show: (cbOk, cbErr, watchId) => {
  //   return modelService.show(cbOk, cbErr, `/watch/${watchId}.json`)
  // },

  // update: (cbOk, cbErr, instance) => {
  //   return modelService.update(cbOk, cbErr, instance, `/watch/${instance.id}.json`)
  // },

  projectDelete: (cbOk, cbErr, projectId, watchId) => {
    return modelService.delete(cbOk, cbErr, `/projects/${projectId}/watches/${watchId}.json`)
  },

  boardDelete: (cbOk, cbErr, boardId, watchId) => {
    return modelService.delete(cbOk, cbErr, `/boards/${boardId}/watches/${watchId}.json`)
  },

  ticketDelete: (cbOk, cbErr, ticketId, watchId) => {
    return modelService.delete(cbOk, cbErr, `/tickets/${ticketId}/watches/${watchId}.json`)
  }
}



// WEBPACK FOOTER //
// ./src/services/watch.js